// extracted by mini-css-extract-plugin
export default {"autoGrow":"Arena_autoGrow__7-s8X"};